<template>
	<div id="skills" class='container'> 
        <div class='parts'>
            <h6 class='heading'>{{$t('h-develop')}}</h6>
            <p>{{$t('skills-content-1')}}<br><br>
            [ ME RIGHT NOW ]<br><br>
            FRONT : 
            <i class="fab fa-css3"></i> /
            <i class="fab fa-vuejs"></i> /
            <i class="fab fa-js-square"></i> /
            <i class="fab fa-sass"></i><br> 
            BACK: <i class="fab fa-laravel"></i> <br>
            DATABASE: <i class="fas fa-database"></i> <br><br>
            </p>

            <!-- <object style='position:sticky;top:100px;transition:1s;' type="image/svg+xml" data="img/radar.svg">Your browser does not support SVGs</object> -->

        </div>

        <div class='parts'>
            <br><br><br>
            <accordion title='LANGUAGE'>
                <ul class='list3'>
                    <li title='Noob'><label style='--skill-level:100%;'><i class="fab fa-php"></i> PHP</label></li>
                    <li title=''><label style='--skill-level:100%;'><i class="fas fa-database"></i> MYSQL</label></li>
                    <hr>
                    <li title=''><label style='--skill-level:100%;'><i class="fab fa-js"></i> JAVASCRIPT</label></li>
                    <li title=''><label style='--skill-level:100%;'>JAVA</label></li>
                    <li title=''><label style='--skill-level:100%;'>DART</label></li>
                </ul>
                
            </accordion>
             <accordion title='FRAMEWORK'>
                 <ul class='list3'>
                    
                    <li title=''><label style='--skill-level:100%;'><i class="fab fa-laravel"></i> LARAVEL</label></li>
                    <li title=''><label style='--skill-level:100%;'>YII2</label></li>
                    <li title=''><label style='--skill-level:100%;'><i class="fab fa-vuejs"></i>  VUE.js</label></li>
                    <li title=''><label style='--skill-level:100%;'>FLUTTER</label></li>
                    <hr>
                    <li title=''><label style='--skill-level:100%;'><i class="fab fa-sass"></i> SASS</label></li>
                    <li title=''><label style='--skill-level:100%;'><i class="fab fa-bootstrap"></i> BOOTSTRAP</label></li>
                    <li title=''><label style='--skill-level:100%;'>MATERIALIZE</label></li>
                    <li title=''><label style='--skill-level:100%;'>BULMA</label></li>
                    
                    
                 </ul>
                <ul class='list1'>
                    <li><p>Node</p><span>Scripts</span></li>
                    <li><p>SSH</p></li>
                </ul>

            </accordion>
            <accordion title='SOFTWARE'>
                <ul class='list3'>
                    <li title='Confident'><label style='--skill-level:100%;'>PHOTOSHOP</label></li>
                    <li title='Not Quite there yet'><label style='--skill-level:100%;'>ILLUSTRATOR</label></li>
                    <li title='Confident'><label style='--skill-level:100%;'>PREMIERE PRO</label></li>
                    <li title='Confident'><label style='--skill-level:100%;'>LIGHTROOM</label></li>
                    <li title='Confident'><label style='--skill-level:100%;'>XAMPP</label></li>
                    <li title='Confident'><label style='--skill-level:100%;'>FILEZILLA</label></li> 
                </ul>
            </accordion>
            <accordion title='DEV METHODS'>
                <ul class='list1'>
                    <li title='Used'><p>Agile</p></li>
                    <li title='Used'><p>Scrum</p> </li>
                    <li title='Used'><p>Waterfall</p> </li>
                    
                
                </ul>
            </accordion>    
            <accordion title='DEV OPS'>
                <ul class='list1'>
                    <li title='Confident'><p>Amazon Web Services</p></li>
                    <li title='Not Quite there yet'><p>Azure</p> </li>
                    <li title='Not Quite there yet'><p>Github</p> </li>
                
                </ul>
            </accordion>      
            <br>
            <p class='txtHide'>{{$t('skills-content-2')}}</p><br>
        </div>

	</div>
	

 

</template>

<script>
import Accordion from '@/components/Accordion'
export default {
    name:"page-skill",
    components:{
        Accordion
    }
}
</script>

